
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class FormWidthEditor extends Serenity.Select2Editor<any, any> {

        constructor(element: JQuery) {
            super(element);

            this.addOption("col-xs-12", "Full");
            this.addOption("col-sm-6", "Half");
            this.addOption("col-md-4", "One Third");
            this.addOption("col-md-8", "Two Third");
            this.addOption("col-lg-3 col-sm-6", "Quarter");
            this.addOption("col-lg-9", "Three Quarter");
        }
    }
}